import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Gift } from "lucide-react";
import { API } from "@/lib/api";
import GiftCard from "@/components/reader/GiftCard";

export default function GiftCardPage() {
  const { token } = useParams();
  const [gift, setGift] = useState(undefined);
  useEffect(() => {
    axios.get(`${API}/reader/gift/card/${encodeURIComponent(token)}`).then((r) => setGift(r.data)).catch(() => setGift(null));
  }, [token]);

  return (
    <div className="pt-32 pb-24 px-6 sm:px-8 max-w-4xl mx-auto" data-testid="gift-card-page">
      <p className="flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.25em] text-primary-gold"><Gift className="w-4 h-4" /> Your gift card</p>
      {gift === undefined ? (
        <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 text-primary-gold animate-spin" /></div>
      ) : gift === null ? (
        <p className="text-soft mt-6" data-testid="gift-card-not-found">We couldn't find this gift card. Check the link in your receipt email.</p>
      ) : (
        <>
          <h1 className="font-serif-display text-4xl sm:text-5xl mt-4">Print it, save it, share it.</h1>
          <p className="text-soft mt-4" data-testid="gift-card-page-status">
            Code <span className="font-mono-ui text-primary-gold">{gift.code}</span> ·{" "}
            {gift.redeemed ? "already redeemed — your friend is reading!" : "not redeemed yet"}
          </p>
          <GiftCard gift={gift} />
          <Link to="/reader/gift" className="inline-block mt-10 font-mono-ui text-xs uppercase tracking-[0.18em] text-soft hover:text-primary-gold">Give another gift →</Link>
        </>
      )}
    </div>
  );
}
